import { HeroSection } from "../components/marketing/HeroSection";

export default function HomePage() {
  return (
    <>
      {/* background layer just for Home */}
      <div className="fixed inset-0 -z-10 bg-[#0b1d36]" />

      <main className="relative min-h-screen text-white">
        <HeroSection />
      </main>
    </>
  );
}
